/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Payload for getting user-level metrics summary
 */
export type GetUserMetricsSummaryPayload = {
  /**
   * Optional account type filter ('team' or 'personal')
   */
  accountType?: string | undefined;
  /**
   * Optional event source filter (e.g. 'hook')
   */
  eventSource?: string | undefined;
  /**
   * Optional filter to a single AI account by its provider org id; scopes metrics to that one account
   */
  externalOrgId?: string | undefined;
  /**
   * External user ID to get metrics for (mutually exclusive with user_id)
   */
  externalUserId?: string | undefined;
  /**
   * Start time in ISO 8601 format
   */
  from: Date;
  /**
   * Optional hook source filter (e.g. 'cursor', 'claude-code')
   */
  hookSource?: string | undefined;
  /**
   * End time in ISO 8601 format
   */
  to: Date;
  /**
   * User ID to get metrics for (mutually exclusive with external_user_id)
   */
  userId?: string | undefined;
};

/** @internal */
export type GetUserMetricsSummaryPayload$Outbound = {
  account_type?: string | undefined;
  event_source?: string | undefined;
  external_org_id?: string | undefined;
  external_user_id?: string | undefined;
  from: string;
  hook_source?: string | undefined;
  to: string;
  user_id?: string | undefined;
};

/** @internal */
export const GetUserMetricsSummaryPayload$outboundSchema: z.ZodMiniType<
  GetUserMetricsSummaryPayload$Outbound,
  GetUserMetricsSummaryPayload
> = z.pipe(
  z.object({
    accountType: z.optional(z.string()),
    eventSource: z.optional(z.string()),
    externalOrgId: z.optional(z.string()),
    externalUserId: z.optional(z.string()),
    from: z.pipe(z.date(), z.transform(v => v.toISOString())),
    hookSource: z.optional(z.string()),
    to: z.pipe(z.date(), z.transform(v => v.toISOString())),
    userId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      accountType: "account_type",
      eventSource: "event_source",
      externalOrgId: "external_org_id",
      externalUserId: "external_user_id",
      hookSource: "hook_source",
      userId: "user_id",
    });
  }),
);

export function getUserMetricsSummaryPayloadToJSON(
  getUserMetricsSummaryPayload: GetUserMetricsSummaryPayload,
): string {
  return JSON.stringify(
    GetUserMetricsSummaryPayload$outboundSchema.parse(
      getUserMetricsSummaryPayload,
    ),
  );
}
